import { DateTime } from 'luxon';

import { useUid } from '@rygen/rygen-ui/composables';
import {
  CorsairDocumentType,
  DocumentParentEntity,
  IDocument,
  Module,
} from '@rygen/rygen-ui/model';
import { loadLuxonDateTime } from '@rygen/rygen-ui/util';

import { DocumentSource } from './DocumentSource';

export class SignedDocument implements IDocument {
  id?: number;
  parentId?: number;
  parentEntity?: DocumentParentEntity;
  types: CorsairDocumentType[] = [];
  documentName?: string;
  fileName?: string;
  contentType?: string;
  contentLength?: string;
  signedUrl?: string;
  createdBy?: string;
  createdDate?: DateTime;
  source?: DocumentSource;
  file?: File;
  uid: string;

  constructor(opts?: Partial<SignedDocument>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.parentId != null) {
      this.parentId = opts.parentId;
    }
    if (typeof opts?.parentEntity === 'string') {
      this.parentEntity = DocumentParentEntity[opts.parentEntity];
    } else if (opts?.parentEntity != null) {
      this.parentEntity = opts.parentEntity;
    }
    if (opts?.types != null) {
      this.types = opts.types.map((val) => {
        return typeof val === 'string' ? CorsairDocumentType[val] : val;
      });
    }
    if (opts?.documentName != null) {
      this.documentName = opts.documentName;
    }
    if (opts?.fileName != null) {
      this.fileName = opts.fileName;
    }
    if (opts?.contentType != null) {
      this.contentType = opts.contentType;
    }
    if (opts?.contentLength != null) {
      this.contentLength = opts.contentLength;
    }
    if (opts?.signedUrl != null) {
      this.signedUrl = opts.signedUrl;
    }
    if (opts?.createdBy != null) {
      this.createdBy = opts.createdBy;
    }
    if (opts?.file != null) {
      this.file = opts.file;
    }
    if (typeof opts?.source === 'string') {
      this.source = DocumentSource[opts.source];
    } else if (opts?.source != null) {
      this.source = opts.source;
    }
    this.createdDate = loadLuxonDateTime(opts?.createdDate);
    if (opts?.uid != null) {
      this.uid = opts.uid;
    } else {
      this.uid = useUid('SignedDocument').uid;
    }
  }

  get sourceModule() {
    return Module.TMS;
  }
}
